import React, { useState } from 'react';
import { Autocomplete, baseColors } from '@groupby/ui-components';
export const AttributeAutocompleteControlComponent = ({ name, disabled, clearAfterSelect, helperText, label, error, options, value, setValue, variant, onBlur, handleChange, }) => {
    const [inputValue, setInputValue] = useState('');
    const onInputChange = (_e, newValue) => {
        setInputValue(newValue);
    };
    const onChange = (_e, value) => {
        const option = value;
        const optionValue = (option === null || option === void 0 ? void 0 : option.value) || '';
        setInputValue(clearAfterSelect ? '' : optionValue);
        if (name && setValue) {
            setValue(optionValue);
        }
        if (handleChange) {
            handleChange(optionValue);
        }
    };
    return (<Autocomplete openOnFocus autoHighlight selectOnFocus clearOnBlur fullWidth background={baseColors.white} id="navigation-autocomplete" value={value} inputValue={inputValue || value} variant={variant} error={error} onBlur={onBlur} onChange={onChange} onInputChange={onInputChange} label={label} helperText={helperText} disabled={disabled} options={options} disableClearable={!inputValue && !value} getOptionDisabled={(option) => !option.inUse}/>);
};
export default AttributeAutocompleteControlComponent;
